import React from 'react';
import './DataTableHeader.scss';

const getTitles = (components = []) => {
  if (!Array.isArray(components)) {
    return [];
  }

  const titles = components.map((component = {}) => {
    const { props = {} } = component;
    const { title = '', sortable = false, source = '' } = props;
    return { title, sortable, source };
  });

  return titles;
};

const DataTableHeader = ({ children = {}, onSort, sortField, sortOrder }) => {
  const titles = getTitles(children);

  const handleSort = (source) => {
    if (typeof onSort === 'function') {
      const newOrder = sortField === source && sortOrder === 'asc' ? 'desc' : 'asc';
      onSort(source, newOrder);
    }
  };

  const renderSortIcon = (source) => {
    if (sortField !== source) {
      return <i className="fas fa-sort sort-icon"></i>;
    }
    return sortOrder === 'asc'
      ? <i className="fas fa-sort-up sort-icon active"></i>
      : <i className="fas fa-sort-down sort-icon active"></i>;
  };

  return (
    <thead>
      <tr>
        {
          titles.map(({ title = '', sortable = false, source = '' }, key) => (
            <th
              key={key}
              className={sortable ? 'sortable' : ''}
              onClick={() => sortable && handleSort(source)}
            >
              {title}
              {sortable && <span className="sort-icon-wrapper">{renderSortIcon(source)}</span>}
            </th>
          ))
        }
      </tr>
    </thead>
  )
};

export { getTitles, DataTableHeader };
